import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';
import { IoMdCheckmarkCircleOutline, IoMdTrophy } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import { GiCheckMark } from "react-icons/gi";
import logo from '../assets/logo.png';
import AOS from 'aos';
import 'aos/dist/aos.css';


export default function HomeBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}
	

	useEffect(() => {
		init();
	}, []);
	
	useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: false,
    });
  }, []);

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if (ready) {
		return (
			<div className="MainBodySection">
				<div
					style={{
						width: "100%",
						height: "auto",
						position: "relative",
						overflow:"auto"
					}}
				>
					{banners.map((banner, i) => (
						<div
							key={i}
							style={{
								backgroundImage: `url(${banner})`,
								backgroundAttachment: "fixed",
								backgroundSize: "cover",
								backgroundPosition: "center",
								width: "100%",
								height: "100%",
								position: "absolute",
								top: 0,
								left: 0,
								transition: "opacity 1.5s ease-in-out",
								opacity: i === bgIndex ? 1 : 0,
							}}
						/>
					))}

					{/* gradient overlay */}
					<div
						style={{
							width: "100%",
							height: "100%",
							background: "rgba(0, 0, 0, 0.5)",
							position: "relative",
							zIndex: 1
						}}
					>
						<div className="container">
							<div className="row">
								<div className="col-md-12 mb-5">

									<h1
										className="font-light text-light"
										style={{
											fontSize: "20px",
											paddingTop: "40px",
											textTransform: "capitalize",
										}}
									>
										Driving community growth through sustainable farming, empowerment, and good governance.
									</h1>

									<h1
										className="font-bold text-light"
										style={{
											fontSize: "36px",
											paddingTop: "20px",
											paddingBottom: "10px",
										}}
									>
										Driving Sustainable Development Across Tanzania
									</h1>

								</div>

								<div className="col-md-12 bg-surface p-5 mb-5">
									<div className="main-section-title">
										OUR OBJECTIVES
									</div>
									
									<div className="row">
										<div className="col-md-9">
											<h6 className="text-dim font-light mb-5">
												The objectives and purposes of the Organization are;
											</h6>

											<h1
												data-aos="fade-right"
											className="font-bold text-dark"
											style={{
												fontSize: "18px",
											}}
											>
												<GiCheckMark className="text-secondary mb-3" size={24} /> To promote sustainable agricultural production and productivity by addressing climate change and global warming issues.
											</h1>

											<h1
												data-aos="fade-right"
												className="font-bold text-dark"
												style={{
													fontSize: "18px",
												}}
											>
												<GiCheckMark className="text-secondary mb-3" size={24} /> To advocate for women and youth empowerment in development initiatives through participation and capacity building in rural and urban settings.
											</h1>
											
											<h1
												data-aos="fade-right"
												className="font-bold text-dark"
												style={{
													fontSize: "18px",
												}}
											>
												<GiCheckMark className="text-secondary mb-3" size={24} /> To promote social inclusion in programming and implementation of development activities.
											</h1>

											<h1
												data-aos="fade-right"
												className="font-bold text-dark"
												style={{
													fontSize: "18px",
												}}
											>
												<GiCheckMark className="text-secondary mb-3" size={24} /> To Promote environmental conservation in the community.
											</h1>

											<h1
												data-aos="fade-right"
												className="font-bold text-dark"
												style={{
													fontSize: "18px",
												}}
											>
												<GiCheckMark className="text-secondary mb-3" size={24} /> To advocate for good governance and lobby for the economic rights of Tanzanians.
											</h1>
											
										</div>

										<div className="col-md-3 text-center" style={{display:"grid", placeItems:"center"}}>
											<img src={logo} height={200}/>
										</div>
									</div>
								</div>

								
							</div>
							</div>
						</div>
					</div>

				</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
